import { useContext } from "react";
import CurrencyConverterContext from "../context/CurrencyConverterContext";

const useCurrencyConverter = () => {
    const currencyConverterContext = useContext(CurrencyConverterContext);
    if (!currencyConverterContext) {
        throw new Error('CurrencyConverterContext has to be used within <CurrencyConverterContext.Provider>');
    } else {
        return currencyConverterContext
    }
}

export default useCurrencyConverter;